module.exports = __webpack_public_path__ + "static/img/proImg5.d289492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg5.png
// module id = 9V2n
// module chunks = 1